<div class="ps-card ps-gauge-card">
  <div class="ps-card-header">
    <div class="ps-card-heading">
      <span class="ps-card-icon"><ps-outline-icon name="cube"></ps-outline-icon></span>
      <div>
        <h2 class="ps-card-kicker">Materials</h2>
        <p class="ps-card-sub">Materials progress across scopes and suppliers</p>
      </div>
    </div>
    <div class="ps-card-actions">
      <button class="ps-icon-btn" title="Material Tracking Details" (click)="drilldownMaterials()">
        <ps-outline-icon name="cart"></ps-outline-icon>
      </button>
    </div>
  </div>

  <summary-gauge [percent]="materialsOverallComplete" [display]="displayPercent" [statusLabel]="status.label"
    [badgeClass]="status.badgeClass" [gaugeColor]="status.gaugeColor"
    [isActive]="isActive" [playToken]="playToken"></summary-gauge>

  <div class="ps-metric-split">
    <div class="ps-split-item">
      <div class="ps-split-value">{{ scopeCount }}</div>
      <div class="ps-split-label">Scopes</div>
    </div>
    <div class="ps-split-item">
      <div class="ps-split-value">{{ totalItems }}</div>
      <div class="ps-split-label">Total Items</div>
    </div>
    <div class="ps-split-item">
      <div class="ps-split-value">{{ format(lowestScope, 0) }}</div>
      <div class="ps-split-label">Lowest Scope</div>
    </div>
    <div class="ps-split-item">
      <div class="ps-split-value">{{ format(highestScope, 0) }}</div>
      <div class="ps-split-label">Highest Scope</div>
    </div>
  </div>
</div>

<div class="ps-card">
  <div class="ps-section-title">Materials by Scope / Subproject</div>

  <div class="ps-scope" *ngFor="let schema of visibleSchemas">
    <button type="button" class="ps-scope-toggle" (click)="toggleSchema(schema)">
      <ps-outline-icon [name]="isExpanded(schema) ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span class="ps-scope-name">{{ schema.SchemaName }}</span>
      <span class="ps-scope-pct">{{ format(schema.PercentComplete, 0) }}</span>
    </button>
    <div class="ps-scope-bar-row">
      <div class="ps-bar" [ngClass]="tone(schema.PercentComplete)" [class.ps-run]="animateBars">
        <span [style.width]="schema.PercentComplete + '%'"></span>
      </div>
    </div>
    <div class="ps-scope-meta">
      <span>{{ schema.TotalItems || 0 }} items</span>
      <span class="ps-scope-complete">{{ formatPrecise(schema.PercentComplete) }} Completion</span>
    </div>

    <div class="ps-phases" *ngIf="isExpanded(schema) && schema.MaterialsPhases?.length">
      <div class="ps-phase" *ngFor="let phase of schema.MaterialsPhases">
        <div class="ps-phase-row">
          <span>{{ phase.PhaseName }}</span>
          <span class="ps-phase-pct">{{ formatPrecise(phase.PercentComplete) }}</span>
        </div>
        <div class="ps-bar is-thin" [ngClass]="tone(phase.PercentComplete)" [class.ps-run]="animateBars">
          <span [style.width]="phase.PercentComplete + '%'"></span>
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="ps-link ps-view-all" *ngIf="schemas.length > 3 && !showAllScopes"
    (click)="showAllScopes = true">
    View all scopes
    <ps-outline-icon name="chevron-down"></ps-outline-icon>
  </button>
</div>
